import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import styles from './AvailabilityMatrix.module.scss';

export type AvailabilityMatrixStates = 'available' | 'conditional' | 'notAvailable';

export type AvailabilityMatrixItemType = {
  state: AvailabilityMatrixStates;
  icon: ReactNode;
  title: string;
};

type AvailabilityMatrixItemProps = {
  item: AvailabilityMatrixItemType;
  blocked: boolean;
  readonly: boolean;
  onClick?: () => void;
};

export const AvailabilityMatrixItem: FC<AvailabilityMatrixItemProps> = ({ item, blocked, readonly, onClick }) => {
  const classes = classNames(
    styles['matrix-item'],
    { [styles['is-blocked']]: blocked, [styles['read-only']]: readonly },
    styles[item.state === 'notAvailable' ? 'not-available' : item.state],
  );

  return (
    <div
      title={item.title}
      className={classes}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
      tabIndex={readonly ? -1 : 0}
      role={'button'}
    >
      <div className={styles['icon-wrapper']}>{item.icon}</div>
    </div>
  );
};
